import {Fragment} from 'react';

import {ValueReplacesService as Service} from './ValueReplacesService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const typeOut = 2;
  const header = t('menu.defaultValue');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'fieldName', header: t('system.fieldName'), width: 200, matchMode: 'contains'},
      {field: 'replace', header: t('menu.defaultValue'), minWidth: 500, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.type = typeOut;
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'fieldName', header: t('system.fieldName'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'replace', header: t('menu.defaultValue'), InputTextProps: {maxLength: 500}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      item.type = typeOut;
      return Service.create(item);
    },
    updateItem: (id, item) => {
      item.type = typeOut;
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
